const Analytics = () => {
    return (
        <div className="analytics-container">
        </div>
    );
}

export default Analytics;